/* tslint:disable:max-line-length */
import classNames from 'classnames';
import React from 'react';
import { IconTypeProps } from '../types';

export const HeartIcon = ({
  className,
  style,
  color = '#949494',
  onClick,
}: IconTypeProps) => {
  return (
    <svg
      className={classNames(className)}
      onClick={onClick}
      style={style}
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0)">
        <path
          d="M14.4469 1.95937C12.7438 0.509367 10.1969 0.749992 8.61563 2.38124L8 3.01874L7.38438 2.38437C6.10938 1.06562 3.5375 0.271867 1.55313 1.95937C-0.409373 3.63437 -0.512498 6.64062 1.24375 8.45312L7.29063 14.6969C7.48438 14.8969 7.74063 15 7.99688 15C8.25313 15 8.50938 14.9 8.70313 14.6969L14.75 8.45312C16.5125 6.64062 16.4094 3.63437 14.4469 1.95937ZM14.0375 7.75937L8.0125 14.0031L1.9625 7.75937C0.762502 6.52187 0.512502 4.16249 2.20313 2.72187C3.91563 1.25937 5.92813 2.31874 6.66563 3.08124L8 4.45937L9.33438 3.08124C10.0594 2.33124 12.0906 1.26874 13.7969 2.72187C15.4844 4.15937 15.2375 6.51874 14.0375 7.75937Z"
          fill={color}
        />
      </g>
      <defs>
        <clipPath id="clip0">
          <rect width="16" height="16" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
